import * as React from "react";
import Slider from "react-slick";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import articulo from "../img/articulo.jpg";
import renoes from "../img/renoes.jpg";
import consulta from "../img/consulta.jpg";
import busqueda from "../img/busqueda.jpg";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <KeyboardArrowRight
      className="text-amarillo"
      sx={{
        position: "absolute",
        top: "50%",
        right: -25,
        transform: "translateY(-50%)",
        fontSize: 40,
        zIndex: 1,
        cursor: "pointer",
      }}
      onClick={onClick}
      style={{ ...style, display: "block" }}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <KeyboardArrowLeft
      className="text-amarillo"
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: -25,
        transform: "translateY(-50%)",
        color: "#FFD700",
        fontSize: 40,
        zIndex: 1,
        cursor: "pointer",
      }}
    />
  );
}

function Proyects({ isMobile = false }) {
  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    className: "center",
    dots: true,
    centerPadding: "20px",
    slidesToShow: isMobile ? 1 : 2,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const styleCard = {
    width: "90%",
    height: isMobile ? "90%" : "auto",
    marginTop: "20px",
    background: "linear-gradient(45deg, #32323e, #595a60)",
    color: "white",
    padding: 0,
    position: "relative",
  };

  return (
    <div className="p-6">
      <p className="text-white text-[17px] font-semibold">
        Proyectos, Colaboraciones y Publicaciones
      </p>

      <div className="slider-container">
        <Slider {...settings}>
          <div>
            <Card sx={styleCard}>
              <CardContent sx={{ padding: 0 }}>
                <img
                  src={renoes}
                  alt="profile"
                  className={`mt-2 w-full ${
                    isMobile ? "h-[full]" : "h-[300px]"
                  } object-contain`}
                />
                <div>
                  <p className="text-main text-sm text-justify mt-2 p-3">
                    Colaboración en la creacion del sitio web
                    <span>
                      <a
                        className="text-blue-600 underline ml-2 mr-2"
                        href="https://renoes.sep.gob.mx/"
                      >
                        "Renoes"
                      </a>
                    </span>
                    (Registro Nacional de Opciones para Educación Superior), un
                    sistema gestionado por la SEP para facilitar el acceso a la
                    oferta educativa a nivel superior en México.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div>
            <Card sx={styleCard}>
              <CardContent sx={{ padding: 0 }}>
                <img
                  src={articulo}
                  alt="profile"
                  className={`mt-2 w-full ${
                    isMobile ? "h-[200px]" : "h-[300px]"
                  } object-contain`}
                />
                <div>
                  <p className="text-main text-sm text-justify mt-2 p-3">
                    Publicación en la novena edición, No. 2 Vol. 1 de la revista
                    Ingeniantes, correspondiente a noviembre 2022, LATINDEX
                    25671.
                    <span>
                      <br /> <br />
                      <a
                        className="text-blue-600 underline"
                        href="https://citt.itsm.edu.mx/ingeniantes/articulos/ingeniantes9no2vol1/11%20Desarrollo%20e%20implementaci%C3%B3n%20de%20un%20sistema%20de%20informaci%C3%B3n%20web%20para%20el%20programa%20federal.pdf"
                      >
                        Enlace del articulo
                      </a>
                    </span>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div>
            <Card sx={styleCard}>
              <CardContent sx={{ padding: 0 }}>
                <img
                  src={consulta}
                  alt="profile"
                  className={`mt-2 w-full ${
                    isMobile ? "h-[full]" : "h-[300px]"
                  } object-contain`}
                />
                <div>
                  <p className="text-main text-sm text-justify mt-2 p-3">
                    Participación en el desarrollo del sitio web
                    <span>
                      <a
                        className="text-blue-600 underline ml-2 mr-2"
                        href="https://consultapublicarnpdno.segob.gob.mx/"
                      >
                        Registro Nacional de Personas Desaparecidas y No
                        Localizadas
                      </a>
                    </span>
                    por sus siglas (RNPDNO), es una herramienta de búsqueda,
                    administrada y coordinada por la Comisión Nacional de
                    Búsqueda de Personas (CNBP), que recopila y organiza
                    información sobre personas desaparecidas o no localizadas.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div>
            <Card sx={styleCard}>
              <CardContent sx={{ padding: 0 }}>
                <img
                  src={busqueda}
                  alt="profile"
                  className={`mt-2 w-full ${
                    isMobile ? "h-[full]" : "h-[300px]"
                  } object-contain`}
                />
                <div>
                  <p className="text-main text-sm text-justify mt-2 p-3">
                    Participación en el desarrollo del portal
                    <span>
                      <a
                        className="text-blue-600 underline ml-2 mr-2"
                        href="https://busquedageneralizada.gob.mx/"
                      >
                        Búsqueda Generalizada
                      </a>
                    </span>
                    iniciativa del Gobierno de México orientado a la
                    localización masiva de personas desaparecidas y no
                    localizadas en todo el territorio nacional.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </Slider>
      </div>

      <p
        className={`text-main italic mt-7 ${
          isMobile ? "text-sm p-2 text-justify" : "text-md"
        } `}
      >
        Las plataformas aquí mostradas son sistemas gubernamentales en los que
        colaboré como parte del equipo de desarrollo. Las referencias se hacen
        únicamente con fines de portafolio profesional, sin implicar propiedad
        intelectual ni institucional.
      </p>
    </div>
  );
}

export default Proyects;
